// src/component/datatable2/models/PageInput.ts

export interface PageInputResult {
    /** Page to show (1-based). */
    page: number;
    /** False when the typed page was out of range and got clamped. */
    valid: boolean;
}

/** "Go to page" input of the paginator. */
export class PageInput {
    /**
     * A typed page within 1..totalPages is used as is; anything else is
     * clamped: a positive number past the end goes to the last page, the
     * rest (0, negative, not a number) to the first page.
     */
    static resolve(input: unknown, totalPages: number): PageInputResult {
        const page = parseInt(String(input), 10);

        if (!page || page < 1 || page > totalPages) {
            return { page: page > 0 ? totalPages : 1, valid: false };
        }

        return { page, valid: true };
    }
}
